import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BloodGasResultsAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-blood-gas-results-slot',
    templateUrl: './blood-gas-results-slot.component.html',
    styleUrl: './blood-gas-results-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodGasResultsSlotComponent implements SheetSlotComponentBase {

	@Input() action!: BloodGasResultsAction;
	value = null;

	constructor() {
	}
}
